import { useEffect, useState } from "react";
import api from "../lib/api";

/** Turns a media id into an authenticated blob URL for <img> / <video> src */
export function useMediaBlob(id) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    let revoked = false;
    let objUrl = null;
    if (!id) return;
    api.get(`/media/${id}`, { responseType: "blob" }).then((r) => {
      if (revoked) return;
      objUrl = URL.createObjectURL(r.data);
      setUrl(objUrl);
    }).catch(() => {});
    return () => {
      revoked = true;
      if (objUrl) URL.revokeObjectURL(objUrl);
    };
  }, [id]);
  return url;
}
